import React from 'react';
import { Mail, Facebook, Instagram, Youtube } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { useSeo } from '../lib/useSeo';
import { QuoteBlock } from '../components/QuoteBlock';
export function Contact() {
  useSeo({
    title: 'Contact',
    description: "Get in touch with Branka Androjna at Milangela's Soul Garden. Connect via email, Facebook, Instagram, or YouTube.",
    path: '/contact',
    image: 'https://images.unsplash.com/photo-1521903062400-b80f2cb8cb9d?auto=format&fit=crop&q=80&w=2000'
  });
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-236">
      <Header data-id="element-237" />

      {/* Hero */}
      <section className="relative h-[85vh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-238">
        <div className="absolute inset-0 z-0" data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/pjtvKuAo9uV3etLstSEUeH/10-CONTACT-01.jpg" alt="White brick wall with pink flowers in white vases" className="w-full h-full object-cover" data-id="element-240" />
          <div className="absolute inset-0 bg-white/20" data-id="element-241"></div>
        </div>

        <div className="relative z-10 text-center px-6 mt-16" data-id="element-242">
          <h1 className="font-serif text-charcoal text-5xl md:text-6xl mb-2" data-id="element-243">
            Milangela's Soul Garden
          </h1>
          <p className="font-serif text-2xl md:text-3xl text-[#B89B72] mb-12" data-id="element-244">
            Branka Androjna
          </p>

          <p className="font-serif italic text-charcoal text-2xl mb-4" data-id="element-245">
            How to get in contact with me?
          </p>

          <a href="mailto:branka@milangelassoulgarden.com" className="inline-flex items-center gap-2 text-[#B89B72] hover:text-[#9A7D54] transition-colors mb-6" data-id="element-246">
            <span className="w-6 h-6 rounded-full border border-[#B89B72] flex items-center justify-center" data-id="element-247">
              <Mail size={12} strokeWidth={1.5} data-id="element-248" />
            </span>
            <span className="text-lg font-serif italic" data-id="element-249">
              branka@milangelassoulgarden.com
            </span>
          </a>

          <div className="flex items-center justify-center gap-6 text-[#B89B72]" data-id="element-250">
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-251">
              Facebook
            </a>
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-252">
              Instagram
            </a>
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-253">
              Youtube
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-254">
          <WavyDivider fill="#3A3A38" data-id="element-255" />
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="relative bg-charcoal py-24 px-6 overflow-hidden" data-id="element-256">
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-257">
          <div className="text-6xl font-serif text-rose-300 leading-none mb-4" data-id="element-258">
            "
          </div>
          <p className="font-serif text-3xl md:text-4xl text-cream italic leading-snug mb-5" data-id="element-259">
            Trust the magic of new beginnings.
          </p>
          <p className="text-cream-100/70 text-sm tracking-widest uppercase" data-id="element-260">
            — Meister Eckhart
          </p>
        </div>
      </section>

      <Footer data-id="element-261" />
    </div>;
}